import PropTypes from "prop-types";
import { useMediaQueryContext } from "lib/mediaQueryContext";
import Stores from "components/product/stores/Stores";
import Usps from "components/product/usps/Usps";
import Acceptants from "components/shared/acceptants/Acceptants";
import Configurator from "components/product/configurator/Configurator";
import Breadcrumbs from "components/shared/breadcrumbs/Breadcrumbs";
import UspTicker from "components/shared/uspTicker/UspTicker";
import Title from "components/shared/hero/title/Title";
import Description from "components/shared/hero/description/Description";

import {
    SimpleHero,
    BackgroundImage,
    BannerCard,
    Image,
    InfoAboutUs
} from "./Product.styled";

function Product({ breadcrumbs }) {
    const { mobileView, desktopView } = useMediaQueryContext();

    return (
        <>
            <SimpleHero>
                <BackgroundImage />
                {desktopView && (
                    <>
                        {breadcrumbs.length !== 0 && (
                            <Breadcrumbs items={breadcrumbs} />
                        )}
                        <UspTicker type="inverted" />
                    </>
                )}
            </SimpleHero>

            <BannerCard>
                <Title align="left">Cadeaukaart bestellen</Title>
                <Description align="left">
                    Bestel hier eenvoudig jouw Lees! Cadeaukaart. Deze wordt
                    standaard geleverd in een leuke cadeau-envelop! De ontvanger
                    kan de kaart zowel online als in de winkels inwisselen!
                </Description>
                <Image
                    src="/images/pdp-card.webp"
                    alt="lees! cadeaukaart"
                    width={960}
                    height={622}
                    quality={100}
                />
                {desktopView && (
                    <InfoAboutUs>
                        <Stores />
                        <Usps />
                    </InfoAboutUs>
                )}
            </BannerCard>

            <Configurator />

            {mobileView && (
                <InfoAboutUs>
                    <Stores />
                    <Usps />
                </InfoAboutUs>
            )}

            <Acceptants
                title="Benieuwd naar hoe jij de ontvanger kan verrassen?"
                description="Met de Lees! Cadeaukaart kan de gene die jij wil verrassen
                        zich ontspannen dankzij het brede assortiment aan
                        tijdschriften, boeken en e-books. Hier zie je al een
                        aantal populaire items uit het brede assortiment van
                        onze acceptanten. Zo geef je een persoonlijk cadeau aan
                        de ontvanger!"
                buttons="acceptants"
            />
        </>
    );
}

Product.propTypes = {
    breadcrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string
        })
    )
};

Product.defaultProps = {
    breadcrumbs: [{ title: "Bestellen", url: "/lees-cadeaukaart-bestellen" }]
};

export default Product;
